import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  Color,
  Cartesian3,
  BingMapsImageryProvider,
  BingMapsStyle,
  UrlTemplateImageryProvider,
} from "cesium";
import {
  Viewer,
  Scene,
  Camera,
  CameraFlyTo,
  Globe,
  KmlDataSource,
} from "resium";

import DynamicImageryLayer from "@/components/layer/DynamicLayerLoader";
import MouseCoordinateLayer from "@/components/layer/MouseCoordinateLayer";
import PointLayer from "@/components/layer/PointLayer";
import RectangleLayer from "@/components/layer/RectangleLayer";
import DrawControl from "@/components/layer/DrawControl";
import { selectLayers } from "@/selector";
import useWindowDimensions from "@/hook/useWindowDimensions";
import "@/components/ArcticViewer.less";

const bgColor = Color.fromBytes(35, 35, 35, 0.5);
const token = "a0e5adf3f1b5ec9d9a57465febe6baad";
const tdtUrl = "https://t{s}.tianditu.gov.cn/";
const subdomains = ["0", "1", "2", "3", "4", "5", "6", "7"];

const ArcticViewer = ({ location }) => {
  const params = new URLSearchParams(location?.search);
  const kml = params.get("kml");

  const { width } = useWindowDimensions();
  const layers = useSelector(selectLayers);
  const destination = Cartesian3.fromDegrees(
    180.1,
    90.1,
    width > 4000 ? 18000000 : 11000000
  );

  const imageryProvider = useMemo(
    () =>
      new BingMapsImageryProvider({
        url: "https://dev.virtualearth.net",
        key: "Ahv1KDJwbpJl4V8zklaRXcoueWXoNLo16osJiU4Zk07vc-VNNzJ0gB81TZyPqNFz",
        mapStyle: BingMapsStyle.AERIAL,
      }),
    []
  );

  // const imageryProvider = useMemo(() => new UrlTemplateImageryProvider({
  //     url: tdtUrl + 'DataServer?T=img_w&x={x}&y={y}&l={z}&tk=' + token,
  //     subdomains: subdomains,
  //     maximumLevel: 18
  // }), [])

  return (
    <Viewer
      full={true}
      animation={false}
      timeline={false}
      sceneModePicker={false}
      baseLayerPicker={false}
      geocoder={false}
      scene3DOnly={true}
      navigationHelpButton={false}
      homeButton={false}
      infoBox={false}
      showRenderLoopErrors={false}
      skyBox={false}
      fullscreenButton={false}
      selectionIndicator={false}
      imageryProvider={imageryProvider}
    >
      <Scene backgroundColor={bgColor} />
      <Globe />
      <Camera defaultZoomAmount={0} />
      <CameraFlyTo duration={0} destination={destination} />
      <DynamicImageryLayer layers={layers} />
      <PointLayer />
      <RectangleLayer />
      <DrawControl />
      <MouseCoordinateLayer />
      {kml && <KmlDataSource data={"/geojson/passage/Route_Yongsheng.kmz"} />}
    </Viewer>
  );
};

export default ArcticViewer;
